import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';
import { Footer } from '../ValuesSection/styles';

import {
  Wrapper,
  StyledContainer,
  Columns,
  Block,
  Content,
  StyledImage,
  TitleWrapper,
  LocationTag,
} from './styles';

// * Difference between this component and ValuesSection
// * This supports CTAs in cards, values supports CTA at bottom of section

// * sectionTiles {obj} richtext obj provided by primsic
// * items {array} array of data from prismic for each card. Contains a heading {string}, image src {string}, bodyCopy {string}, subHeading {string}, and cta info {string}

function LocationSection({ sectionId, data }) {
  if (!data) return null;
  const {
    sectionTitleHtml,
    columnAlignment,
    colourOverrideBackground,
    colourOverrideText,
    items,
    titleHtml,
    buttonLink,
    buttonText,
    buttonType,
    ariaLabelButton,
    queryStringButton,
    lang,
  } = data;

  const textColor = colourOverrideText
    ? `text-${colourOverrideText.toLowerCase()}`
    : 'text-Light';

  return (
    <Wrapper
      id={sectionId}
      colourOverrideBackground={colourOverrideBackground}
      className={textColor}
    >
      <StyledContainer className="auto-margin">
        {ReactHtmlParser(sectionTitleHtml)}
        <Columns className="regular-columns" columns={4}>
          {items.map(
            (
              {
                itemImage,
                imageItemSharp,
                itemHeadingHtml,
                itemBodyCopyHtml,
                itemSubHeadingHtml,
                cta,
                ctaText,
                ariaLabel,
                queryString,
              },
              index,
            ) => (
              <Block
                className={columnAlignment}
                key={`locations-${columnAlignment}-${index.toString()}`}
              >
                {imageItemSharp && (
                <StyledImage src={imageItemSharp} alt={itemImage.altTag} />
                )}
                <Content>
                  <TitleWrapper>
                    {ReactHtmlParser(itemHeadingHtml)}
                    {itemSubHeadingHtml && (
                    <LocationTag>
                      {ReactHtmlParser(itemSubHeadingHtml)}
                    </LocationTag>
                    )}
                  </TitleWrapper>
                  {ReactHtmlParser(itemBodyCopyHtml)}
                  {cta.url && ctaText && (
                  <Link
                    to={cta.url}
                    ariaLabel={ariaLabel}
                    queryString={queryString}
                    lang={lang}
                  >
                    {ctaText}
                  </Link>
                  )}
                </Content>
              </Block>
            ),
          )}
        </Columns>
        {(titleHtml || buttonText) && (
          <Footer>
            {ReactHtmlParser(titleHtml)}
            {buttonLink && buttonText && (
              <Link
                to={`${buttonLink.url}/`}
                className={buttonType}
                ariaLabel={ariaLabelButton}
                queryString={queryStringButton}
                lang={lang}
              >
                {buttonText}
              </Link>
            )}
          </Footer>
        )}
      </StyledContainer>
    </Wrapper>
  );
}

LocationSection.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
};

export default LocationSection;
